import { createSelector } from 'reselect';

import { GridMode } from '../gridEdit/useEditableGridLogic';
import appendIndicatorRenderer from '../gridEdit/validationMessagesIndicatorCellRenderer';
import SelectCellEditor, { baseCellEditorParams } from '../gridEdit/selectCellEditor.component';

import {
  userRoleColumnDefinition,
  descriptionColumnDefinition,
  roleClientColumnDefinition,
} from '../columnDefinitions';
import { editRoleColumnDefinitionFactory } from '../columnDefinitionGenerators';
import { userRolesDictionary } from '../authorization/userRoles';

const editableFactory = () => ({ data, context }) =>
  (context.mode !== GridMode.View && data.roleId === context.editedRowId)
  || (context.mode === GridMode.Add && data.roleId === 0);

const getBaseColumnDefinitions = ( setRowData, clients = [] ) => appendIndicatorRenderer([
  {
    ...userRoleColumnDefinition,
    editable: editableFactory(),
    valueSetter: props => setRowData(props),
    valueGetter: ({ data }) => userRolesDictionary[data.roleName] || data.roleName,
    cellEditorPopup: true,
  },
  {
    ...descriptionColumnDefinition,
    editable: editableFactory(),
    valueSetter: props => setRowData(props),
    cellEditorPopup: true,
  },
  {
    ...roleClientColumnDefinition,
    editable: editableFactory(),
    cellEditor: SelectCellEditor,
    cellEditorPopup: true,
    cellEditorParams: {
      ...baseCellEditorParams,
      withClearIcon: true,
      options: clients,
      defaultEmpty: null,
    },
    valueSetter: ({ node, newValue, colDef }) => {
      const newId = clients?.find(({ value }) => value === newValue)?.clientId ?? null;
      setRowData({ node, field: 'clientName', newValue, colDef });
      setRowData({ node, field: 'clientId', newValue: newId, colDef });
      return true;
    },
  },
]);

const getColumnDefs = ({
  canModify,
  readOnly,
  onEditClick,
  onRemoveClick,
  clients,
  editedRoleId,
  setRowData,
}) => [
  editRoleColumnDefinitionFactory({
    canModify,
    readOnly,
    onEditClick,
    onRemoveClick,
    editedRoleId,
  }),
  ...getBaseColumnDefinitions(setRowData, clients),
];

export default createSelector(
  canModify => canModify,
  readOnly => readOnly,
  onEditClick => onEditClick,
  onRemoveClick => onRemoveClick,
  clients => clients,
  editedRoleId => editedRoleId,
  setRowData => setRowData,
  getColumnDefs
);
